module.exports = __webpack_public_path__ + "img/Mask group blue.5b34d35d.svg";